import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';
import { Grid } from '@nextiva/next-ui-components';
import { actionTypes } from 'containers/pages/Teams/redux';

import { ShadowDom } from './ShadowDom';
import classes from './m-table-header.scss';

const TeamTableHeader = () => {
  const dispatch = useDispatch();
  const { sortField, sortDirection, teamsListIsLoading } = useSelector(
    (state) => state.teamsReduxReducer,
  );

  const handleSort = (e) => {
    const { id } = e.currentTarget;

    if (id === 'userCount') {
      dispatch({
        type: actionTypes.SET_SORT,
        sortField: id,
        sortType: 'number',
      });
    } else {
      dispatch({
        type: actionTypes.SET_SORT,
        sortField: id,
        sortType: 'string',
      });
    }
  };

  return (
    <div className="m-table-header">
      {teamsListIsLoading && <ShadowDom />}
      {!teamsListIsLoading && (
        <Grid container>
          <Grid xs={3} item>
            <div
              role="presentation"
              id="name"
              onClick={handleSort}
              data-testid="PlatformAdminUI-TeamsLink-TeamTableHeader-TeamNameSort"
              className="table-header-item"
            >
              <span
                className={clsx('Heading6', classes.header__text)}
                data-testid="PlatformAdminUI-TeamsLink-TeamTableHeader-TeamName"
              >
                Team
              </span>
              <span
                className={clsx(
                  classes.header__col__text,
                  'sort_icon',
                  sortField === 'name' && `${sortDirection}_icon`,
                )}
                data-testid={`PlatformAdminUI-TeamsLink-TeamTableHeader-TeamName-${sortDirection}-icon`}
              />
            </div>
          </Grid>
          <Grid xs={3} item>
            <div
              role="presentation"
              id="userCount"
              onClick={handleSort}
              data-testid="PlatformAdminUI-TeamsLink-TeamTableHeader-UserCountSort"
              className="table-header-item"
            >
              <span
                className={clsx('Heading6', classes.header__text)}
                data-testid="PlatformAdminUI-TeamsLink-TeamTableHeader-UserCount"
              >
                Users
              </span>
              <span
                className={clsx(
                  classes.header__col__text,
                  'sort_icon',
                  sortField === 'userCount' && `${sortDirection}_icon`,
                )}
                data-testid={`PlatformAdminUI-TeamsLink-TeamTableHeader-UserCount-${sortDirection}-icon`}
              />
            </div>
          </Grid>
          <Grid xs={3} item>
            <div
              role="presentation"
              id="phoneNumber"
              onClick={handleSort}
              data-testid="PlatformAdminUI-TeamsLink-TeamTableHeader-PhoneNumberSort"
              className="table-header-item"
            >
              <span
                className={clsx('Heading6', classes.header__text)}
                data-testid="PlatformAdminUI-TeamsLink-TeamTableHeader-PhoneNumber"
              >
                Phone Number
              </span>
              <span
                className={clsx(
                  classes.header__col__text,
                  'sort_icon',
                  sortField === 'phoneNumber' && `${sortDirection}_icon`,
                )}
                data-testid={`PlatformAdminUI-TeamsLink-TeamTableHeader-PhoneNumber-${sortDirection}-icon`}
              />
            </div>
          </Grid>

          <Grid xs={3} item>
            <div
              role="presentation"
              id="extension"
              onClick={handleSort}
              data-testid="PlatformAdminUI-TeamsLink-TeamTableHeader-ExtensionSort"
              className="table-header-item"
            >
              <span
                className={clsx('Heading6', classes.header__text)}
                data-testid="PlatformAdminUI-TeamsLink-TeamTableHeader-Extension"
              >
                Extension
              </span>
              <span
                className={clsx(
                  classes.header__col__text,
                  'sort_icon',
                  sortField === 'extension' && `${sortDirection}_icon`,
                )}
                data-testid={`PlatformAdminUI-TeamsLink-TeamTableHeader-Extension-${sortDirection}-icon`}
              />
            </div>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default TeamTableHeader;
